import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import routes from "../../routes";
import SidebarListItem from "./SidebarListItem";
import MachineFootballColorIcon from "../../assets/sidebarIcons/MFColorlogo.svg";
import { useSidebar } from "../../contexts/SidebarContext";
import {
  SidebarBottomList,
  SidebarContainer,
  SidebarHeader,
  SidebarImage,
  SidebarList,
  SidebarTitle,
} from "../../styled-components/Sidebar.Styles";
import { IRoute, ISidebarListItem } from "../../types/ISidebarListItem";
import Drawer from "../../ui/Drawer";
import GlobalSearch from "../../components/GlobalSearch/GlobalSearch";
import { useNewPlayerShortlistContext } from "../../contexts/NewPlayerShortlistContext";

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isOpen, toggleSidebar, activeItemId, setActiveItemId, drawerState, toggleDrawer } = useSidebar();
  const allowPresentaion = localStorage.getItem("allowPresentation") === "true";

  useEffect(() => {
    const path = window.location.pathname;
    const matchingRoute = routes.find((route) => route.path === path);

    // console.log(path)

    if (matchingRoute) {
      setActiveItemId?.(matchingRoute.Id);
    } else if (path.includes("/player")) {
      setActiveItemId?.("Players");
    } else if (path.includes("/club")) {
      setActiveItemId?.("Clubs");
    } else if (path.includes("/search")) {
      setActiveItemId?.("Search");
    } else if (path.includes("/shortlists")) {
      setActiveItemId?.("Shortlists");
    }else {
      setActiveItemId?.("Home");
    }
  }, [location.pathname]);

  const bottomRoutes: IRoute[] = routes.filter(
    (route) => route.name === "Logout" || route.name === "Notification" || route.name === "LoginUser" || route.name === "Change Password"
  );

  const mainRoutes: IRoute[] = routes.filter(
    (route) => route.name !== "Logout" && route.name !== "Notification" && route.name !== "LoginUser" && route.name !== "Change Password"
  );
  const handleIdClick = (itemId: string) => {
    if (itemId === "Shortlists") {
      setNewlyAddedPlayerCount(0);
    }
    setActiveItemId?.(itemId);
  };

  const headerClick = () => {
    if (allowPresentaion) {
      navigate("/home");//as per email received from mandhir on 29-May
    } else {
      navigate("/home");
    }
  };
  const { newlyAddedPlayerCount, setNewlyAddedPlayerCount } = useNewPlayerShortlistContext();

  return (
    <>
      <SidebarContainer
        isOpen={!!isOpen}
        className="sidebar-main"
        onMouseEnter={() => toggleSidebar?.(true)}
        onMouseLeave={() => {
          if (!drawerState?.isOpen) toggleSidebar?.(false);
        }}
      >
        <SidebarHeader onClick={() => headerClick()}>
          <SidebarImage src={MachineFootballColorIcon} alt="Open Sidebar" isOpen={!!isOpen} onMouseEnter={() => toggleSidebar?.(true)} />
          <SidebarTitle isOpen={!!isOpen}>MachineFootball</SidebarTitle>
        </SidebarHeader>
        <SidebarList className="main-sidebar-top-menu">
          {mainRoutes.map((route, index) => (
            <React.Fragment key={index}>
              <SidebarListItem
                Id={route.Id}
                icon={route.icon}
                text={route.name}
                path={route.path}
                updates={
                  route.name === "Shortlists"
                    ? newlyAddedPlayerCount > 0
                      ? newlyAddedPlayerCount
                      : undefined
                    : route.name === "Notification"
                    ? 0
                    : undefined
                } // Pass updates only for 'Bookmarks' and 'Notification'
                submenu={route.submenu ? mapRoutesToSidebarListItemProps(route.submenu) : undefined}
                shouldNavigate={route.shouldNavigate}
                isActive={activeItemId === route.Id}
                onClick={(Id: string) => handleIdClick(Id)}
                subNav={route.subNav}
              />
            </React.Fragment>
          ))}
        </SidebarList>
        <SidebarBottomList>
          {bottomRoutes.map((route, index) => (
            <React.Fragment key={index}>
              <SidebarListItem
                Id={route.Id}
                icon={route.icon}
                text={route.name}
                path={route.path}
                updates={route.name === "Bookmarks" ? 2 : route.name === "Notification" ? 0 : undefined} // Pass updates only for 'Bookmarks' and 'Notification'
                submenu={route.submenu ? mapRoutesToSidebarListItemProps(route.submenu) : undefined}
                shouldNavigate={route.shouldNavigate}
                isActive={activeItemId === route.Id}
                onClick={(Id: string) => handleIdClick(Id)}
                subNav={route.subNav}
              />
            </React.Fragment>
          ))}
        </SidebarBottomList>
      </SidebarContainer>
      {drawerState?.isOpen && (
        <Drawer
          open={drawerState?.isOpen!}
          onClose={() => {
            toggleDrawer?.(false);
          }}
          customClassName="global-search-drawer"
        >
          {/* {drawerState.contentType === "player" && <PlayerInitialSearch />} */}
          {drawerState.contentType === "search"  && <GlobalSearch />}
        </Drawer>
      )}
    </>
  );
};

// Utility function to map routes to SidebarListItemProps
function mapRoutesToSidebarListItemProps(routes: IRoute[]): ISidebarListItem[] {
  return routes.map((route) => ({
    Id: route.Id,
    isOpen: false, // Set to false as submenu items should not have isOpen initially
    icon: route.icon,
    text: route.name,
    path: route.path,
    shouldNavigate: route.shouldNavigate,
    subNav: route.subNav,
  }));
}

export default Sidebar;
